import React, { useState } from "react";
import classNames from "classnames/bind";
import styles from "./Filter.module.css";
import { TimeIcon } from "../../../../components/Icons/Icons";
import DateTimePicker from "../../../../components/DateTimePicker/DateTimePicker";
import { CustomCalendar } from "../../../../components";

const cx = classNames.bind(styles);
const Filter = ({ onChangeDayEnd, onChangeDayStart, timeStart, timeEnd, isFilter, onOk,dayHl }) => {
  const [isFormTime, setIsFormTime] = useState(false)
  const [start, setStart] = useState('00:00')
  const [end, setEnd] = useState('23:59')
  const handleFilter = () => {
    onOk(start, end)
    setIsFormTime(false)
  }

  const handleCancel = () => {
    setStart('00:00')
    setEnd('23:59')
    setIsFormTime(false)
  }
  return (
    <div className={cx("filter")}>
      <div style={{ flex: 1, marginTop: '8px' }}>
        <CustomCalendar value={timeStart} title={'Bắt đầu'} onChange={onChangeDayStart} dayHl={dayHl} />
      </div>
      <div style={{ flex: 1, marginTop: '8px' }}>
        <CustomCalendar value={timeEnd} title={'Kết thúc'} onChange={onChangeDayEnd} dayHl={dayHl} />
      </div>
      <div style={{ flex: 1, paddingTop: '10px' }}>
        <label className={cx("label")}>Khung giờ</label>
        <div className={cx("value")}>
          <div style={{ width: "100%" }} onClick={(e) => setIsFormTime(!isFormTime)}>{isFilter && start && end ? `${start}-${end}` : "Lựa chọn"}</div>
          <span onClick={(e) => setIsFormTime(!isFormTime)} className={cx("icon")}>
            <TimeIcon />
          </span>
          {
            isFormTime && <div className={cx("time")}>
              <div className={cx("start")}>
                <label className={cx("label-time")}>Giờ bắt đầu</label>
                <input value={start} onChange={(e) => setStart(e.target.value)} className={cx("input-time")} type={"time"} />
              </div>
              <div onChange={(e) => setEnd(e.target.value)} className={cx("end")}>
                <label className={cx("label-time")}>Giờ kết thúc</label>
                <input value={end} className={cx("input-time")} type={"time"} />
              </div>
              <div className={cx("action")}>
                <button onClick={handleFilter} className={cx("btn-time", "ok")}>Xác nhận</button>
                <button onClick={handleCancel} className={cx("btn-time", "cancel")}>Hủy bỏ</button>
              </div>
            </div>
          }

        </div>
      </div>
    </div>
  );
};

export default Filter;
